"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemCodeField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const purchases_1 = require("@completeanatomy/purchases");
const styled_components_1 = __importDefault(require("styled-components"));
const OneSymbolInput_1 = require("../../atoms/OneSymbolInput/OneSymbolInput");
const mediaQueries_1 = require("../../styles/mediaQueries");
function RedeemCodeField(_a) {
    var { onChange: onChangeProp, code } = _a, props = __rest(_a, ["onChange", "code"]);
    const { onPaste, onKeyDown, onChange, ref: inputsRef, } = (0, purchases_1.useRedeemInputs)(code, onChangeProp);
    return ((0, jsx_runtime_1.jsx)(Container, Object.assign({ onPaste: onPaste }, props, { "data-e2e": 'RedeemCodeField_Container', children: code.map((symbol, i) => ((0, jsx_runtime_1.jsx)(OneSymbolInput_1.OneSymbolInput, { ref: inputsRef(i), value: symbol, onKeyDown: onKeyDown(i), onChange: onChange(i), "data-e2e": 'RedeemCodeField_OneSymbolInput' }, i))) })));
}
exports.RedeemCodeField = RedeemCodeField;
const Container = styled_components_1.default.div `
  display: grid;
  column-gap: 16px;
  row-gap: 20px;
  grid-template-columns: repeat(6, max-content);

  ${mediaQueries_1.device.mobileLandscape `
    grid-template-columns: repeat(12, max-content);
    column-gap: 8px;
  `}
`;
